import { email } from 'redux-form-validators'

export const ZIPCODE_SYNTAX = /^[0-9]{5}$/i
export const TIME_SYNTAX = /^(0[1-9]|1[0-2]):[0-5][0-9] [AP]M$/
export const EMAIL_SYNTAX = email.REG_EMAIL
